<template>
    <!-- <el-page-header style="padding: 20px" @back="goback" :content="content"></el-page-header> -->
    <div class="el-page-header" style="padding: 20px;">
        <div class="el-page-header__left" @click="goback">
            <i class="el-icon-arrow-left"></i>
            <div class="el-page-header__title">返回</div>
        </div>
        <div class="el-page-header__content">{{ content }}</div>
    </div>
</template>

<script>
export default {
    name: 'pageHeader',
    props: ['content'],
    methods: {
        goback() {
            this.$emit('back')
        }
    }
}
</script>
<style lang="scss" scoped>
.el-page-header__left{
    align-items: center;
    .el-icon-arrow-left {
        font-size: 18px;
        margin-right: 6px;
        align-self: center;
    }
}
</style>
